import React, { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

interface ProtectedRouteProps {
  children: ReactNode;
  requiredRole: 'business-admin' | 'super-admin';
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requiredRole }) => {
  const { user, isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/admin/login" replace />;
  }

  // Handle both formats: business_admin and business-admin
  const normalizedUserRole = user?.role.replace('_', '-');
  const normalizedRequiredRole = requiredRole.replace('_', '-');

  // For business-admin route, allow end_user as well (default)
  if (requiredRole === 'business-admin') {
    if (normalizedUserRole === 'business-admin' || user?.role === 'end_user') {
      return <>{children}</>;
    }
  }

  // For super-admin route, only allow super admins
  if (requiredRole === 'super-admin') {
    if (normalizedUserRole === 'super-admin') {
      return <>{children}</>;
    }
  }

  return <Navigate to="/admin/login" replace />;
};

export default ProtectedRoute;

